.btn-wrapper {
  align-items: center;
  display: flex;
  height: 100%;
  inset: 0;
  justify-content: center;
  pointer-events: none;
}

button {
  --size: 32px;
  align-items: center;
  background-color: white;
  border-radius: var(--size);
  border: none;
  color: black;
  cursor: pointer;
  display: flex;
  height: var(--size);
  justify-content: center;
  pointer-events: auto;
  position: relative;
  width: var(--size);
}

.carousel-button {
  position: absolute;
  top: calc(var(--carousel-arrow-wrap-height, 100%) / 2 - (var(--size) / 2));
}

ui-chevron-arrow-icon {
  --size: 24px;
  color: black;
  height: var(--size);
  width: var(--size);
}
